

















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { isLogin, getSchema, getTaskExp, getTaskExpColumns } from '@/global/utils'
import { DOMAIN, SERVER_HOST, HTTPDOMAIN, mobileProject, JIDU_DOMAIN} from '@/global/constants'
import { getValidate, taskSign, getToken, validate } from '@/api/task/crowd'
import { getFromType, getQiniuToken, partnerBatchAnswer } from '@/api/task/common'
import { getFreezeList } from '../../api/user/user'
import $ from 'jquery'
// import * as qiniu from 'qiniu-js'
import { uploadOss } from '@/global/utils'
import { getToken as getSSID} from '@/global/utils'

const RealName = () => import('@/components/realName.vue')

@Component({
  components: {
    RealName
  }
})
export default class CrowdDetailHeader extends Vue {
  @Prop() private task!: object
  @Prop() private currentPage!: string
  private keyword: string = process.env.VUE_APP_KEYWORD;
  // 显示数据模型
  private taskSchema: any
  //任务显示经验值
  private taskExp: any
  //任务详情页经验值title
  private columns: any
  // 显示实名认证
  private nameData: object = {}
  // 实名认证信息
  private realNameMsg: string[] = [
    '该实名信息只用于平台任务及提现的法律凭证，不做其他用途',
    `一个身份证只可绑定一个${this.keyword}ID`,
    '每日认证超过5次当天将不可再认证，请认真核实后进行提交'
  ]
  // 实名认证 modal
  private realNameShow: boolean = false
  //批量提交弹窗
  private partnerShow: boolean = false
  // 二维码采集
  private showQRCodeModal: boolean = false
  private percent: number = 101
  //批量上传csv-url
  private partnerCSVUrl: string = ''
  // 龙猫协议url 名称 modal check
  private agreementUrl: string = ''
  private agreementName: string = `${this.keyword}协议`
  private proVisible: boolean = false
  private checked: boolean = false
  private stageType = Object.freeze({
    CHECK_STAGE: 1,
    REDO_STAGE: 2
  })
  private modualTaskType = Object.freeze({
    1: 51,
    2: 52,
    3: 53,
    4: 54,
    5: 55,
    6: 56,
    7: 57,
    9: 52,
    10: 55
  })
  get userInfo() {
    return this.$store.state.userInfo
  }
  get myExp() {
    return this.$store.state.myExp
  }

  @Watch('myExp')
  private userIdChange(to: any, from: any) {
    if (to) {
      const list = getTaskExp(this.task, this)
      list.forEach((item, index) => {
        Vue.set(this.taskExp, index, item)
      })
      // this.taskExp = getTaskExp(this.task,this);
    }
  }
  private created() {
    this.taskSchema = getSchema(this.task)
    if(this.userInfo && this.userInfo.team_general_user){
      this.taskSchema.pop()
    }
    this.taskExp = getTaskExp(this.task, this)
    this.columns = getTaskExpColumns()
  }
  // 打开实名认证弹窗
  private openRealName() {
    this.realNameShow = true
  }
  // 关闭实名认证弹窗
  private closeRealName() {
    this.realNameShow = false
  }

  // 优先审核
  private handlerCheckFirst() {
    const task = this.task as any
    this.$router.push({
      name: 'checkfirst',
      params: { id: task.id, page: 'crowd' }
    })
  }
  // 做题
  private async handlerStartLib(type) {
    if (!isLogin(this)) {
      return
    }
    const task: any = this.task
    if (task.type === 8) {
      this.showQRCodeModal = true
      return
    }
    // 是否有做题权限: 未实名认证或未签署协议
    const res: any = await getValidate({ id: task.id })
    if (res.code === '510004') {
      this.realNameShow = true
    } else if (res.code === '510006') {
      this.agreementUrl = task.agreementInfo ? task.agreementInfo.url : ''
      this.agreementName = task.agreementInfo ? task.agreementInfagreement_name : `${this.keyword}协议`
      this.proVisible = true
      this.checked = false
    } else if (res.code === '200') {
      console.log('已经实名认证但不用签署协议或实名认证并签署协议')
      if (task.type == 7) {
        const resp: any = await getToken({ type: task.outside_type })
        if (resp.code === '200') {
          this.openEditor(null, resp)
        } else {
          this.$Modal.error({
            title: '无法做题',
            content: resp.message
          })
        }
      } else {
        if (type === 'redo') {
          this.openEditor(this.stageType.REDO_STAGE, null)
        } else {
          this.openEditor(null, null)
        }
      }
    } else {
      this.$Modal.error({
        title: '无法做题',
        content: res.message
      })
    }
  }
  // 做题 跳转页面
  private openEditor(stage, token) {
    let url = `${DOMAIN}/tools/`
    const task: any = this.task
    // 移动asr项目 https无法访问 改为http访问
    if(task.id && mobileProject.indexOf(task.id *1) > -1){
      url = `${HTTPDOMAIN}/tools/`
    }
    if (task.type === 7) {
      if (task.outside_url) {
        url += `platform.html?url=1&token=${token.result.token}`
      }
    } else if(task.from === 'jiduNlpPage'){
      //JiDu 兼容jiduNlpPage
      const tokenTemp = getSSID()
      url = `${JIDU_DOMAIN}/nlp`+`?type=${this.modualTaskType[task.type]}&id=${task.id}&version=2&_ssid=${tokenTemp}`
      url += !stage ? '' : `&stage=${stage}`
    }else {
      if (/^sketch(-.+)?$/.test(task.from)) {
        const parts = task.from.split('-')
        url += `${parts.length > 1 ? parts[1] : 'markPage'}.html`
      } else if (task.from) {
        url += task.from + '.html'
      } else {
        url += 'markPage.html'
      }
      url += `?type=${this.modualTaskType[task.type]}&id=${task.id}&version=2`
      url += !stage ? '' : `&stage=${stage}`
    }
    window.open(url)
  }

  // 质检（crowd）
  private handlerInspectLibs() {
    if (!isLogin(this)) {
      return
    }
    const task = this.task as any
    if(task.from =='partnerPage'){
      this.$router.push({
            name: 'inspect',
            params: { page: 'crowd', id: task.id },
          });
    }else{
      this.$router.push({
            name: 'inspectUser',
            params: { page: 'crowd', id: task.id },
          });
    }

    // if(this.$store.state.userInfo &&
    // (this.$store.state.userInfo.id == 2522490
    // || this.$store.state.userInfo.id ==3548156
    // || this.$store.state.userInfo.id ==2991095
    // || this.$store.state.userInfo.id > 3000000)){
    //   this.$router.push({
    //         name: 'inspectUser',
    //         params: { page: 'crowd', id: task.id },
    //       });
    // }else{
    //   this.$router.push({
    //         name: 'inspect',
    //         params: { page: 'crowd', id: task.id },
    //       });
    // }
  }

  // 协议同意
  private async onProtocolOk() {
    const task: any = this.task as any
    const res: any = await taskSign({ id: task.id })
    if (res.code === '200') {
      this.$Notice.info({
        title: '任务协议',
        desc: '签署成功!'
      })
      this.proVisible = false
    } else {
      this.$Notice.info({ title: '提示', desc: res.message || '请求失败' })
    }
  }
  // 协议拒绝
  private onProtocolClose() {
    this.checked = false
    this.proVisible = false
    this.agreementUrl = ''
  }
  // 审核（只有新审核模块有此按钮）
  private handlerExamine() {
    const task: any = this.task
    if(task.from =='partnerPage'){
      this.$router.push({
          name: 'examine',
          params: { page: 'crowd', id: task.id,pkg_id:'0' }
        })
    }else{
      this.$router.push({
          name: 'examineUser',
          params: { page: 'crowd', id: task.id,pkg_id:'0' }
        })
    }

    // if(this.$store.state.userInfo &&
    // (this.$store.state.userInfo.id == 2522490
    // || this.$store.state.userInfo.id ==3548156
    // || this.$store.state.userInfo.id ==2991095
    // || this.$store.state.userInfo.id > 3000000)){
    //     this.$router.push({
    //       name: 'examineUser',
    //       params: { page: 'crowd', id: task.id,pkg_id:'0' }
    //     })
    // }else{
    //     this.$router.push({
    //       name: 'examine',
    //       params: { page: 'crowd', id: task.id,pkg_id:'0' }
    //     })
    // }
  }
  //partnerPage标注页面批量提交
  private handlerPartnerCsv() {
    if (!isLogin(this)) {
      return
    }
    this.partnerShow = true
  }
  private handleCancelPartner() {
    this.partnerShow = false
  }

  private async handleValidate() {
    if (!this.partnerCSVUrl) {
      alert('请上传csv')
      return
    }
    const task = this.task as any
    const resp: any = await partnerBatchAnswer({
      mid: task.id,
      partnerCSVUrl: this.partnerCSVUrl
    })
    console.log(resp)
    if (resp.code == 200) {
      this.$Message.success('提交成功')
      this.partnerCSVUrl = ''
      this.partnerShow = false
    } else {
      this.$Notice.warning({ desc: resp.message })
    }
  }

  private upDownCsv() {
    const task = this.task as any
    if (task.partner_page_csv) {
          var url = task.partner_page_csv;
          url = url.replace(/^http:\/\//i,'https://');
          var $form = $('<form method="GET"></form>');
          $form.attr('action', url);
          $form.appendTo($('.header'));
          $form.submit();
          $form.remove();
          console.log(url)
    }
  }
  private async upLoad(e){
    let file = e.target.files[0];
    if(!file) return ;
    const task = this.task as any;
    let times = new Date().getTime();
    let extension = file.name.split('.')[1];
    let key = `${task.id}/${times}.${extension}`;
    uploadOss(file, key).then(res => {
      alert('上传完成');
      this.percent = 101;
      this.partnerCSVUrl = res;
      console.log(this.partnerCSVUrl)
    }).catch(err => {
      console.log(err)
      alert('上传失败');
    })
  }
  // private async upLoad(e) {
  //   let resp: any
  //   resp = await getQiniuToken()
  //   const task = this.task as any
  //   let times = new Date().getTime()

  //   let file = e.target.files[0]
  //   if (!file) return
  //   let extension = file.name.split('.')[1]
  //   let key = `${task.id}/${times}.${extension}`
  //   let config = {
  //     useCdnDomain: true,
  //     region: null
  //   }
  //   let putExtra = {
  //     fname: '',
  //     params: {},
  //     mimeType: null,
  //     domain: 'https://static.cdn.longmaosoft.com'
  //   }
  //   let observer = {
  //     next: (res) => {
  //       this.percent = Math.floor(res.total.percent)
  //     },
  //     error(err) {
  //       alert('上传失败')
  //     },
  //     complete: (res) => {
  //       alert('上传完成')
  //       this.percent = 101
  //       this.partnerCSVUrl = `https://static.cdn.longmaosoft.com/${res.key}`
  //       console.log(this.partnerCSVUrl)
  //     }
  //   }
  //   let observable = qiniu.upload(file, key, resp, putExtra, config)
  //   let subscription = observable.subscribe(observer)
  // }
}
